import { useModalContext } from "../../Contexts/ModalContext";

import { modalVariants } from "../../Utils/constants";

const BENEFITS = [
  { title: "$10 Cash Back on Rent", description: "Instant cash back every time you pay rent" },
  { title: "Credit Building", description: "Rent reported to all 3 credit bureaus" },
  { title: "Express PayCheck", description: "Get paid up to 2 days early" },
];

const RedXIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="css-benefit-x-icon">
    <circle cx="10" cy="10" r="9" fill="#E539351F" />
    <line x1="7" y1="7" x2="13" y2="13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="13" y1="7" x2="7" y2="13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const ExclamationIcon = () => (
  <div className="css-exclamation-circle">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 8V13" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="12" cy="17" r="1.5" fill="#FFFFFF" />
    </svg>
  </div>
);

export default function renderCancelStakeSaverModal(modalContext, { onCancel }) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(() => <CancelStakeSaverModal onCancel={onCancel} />);
  setModalVariant(modalVariants.promptDialog);
  setModalTitle("");
  setModalAriaLabel?.("Cancel Stake Saver?");
  setModalClassName("cancel-stake-saver");
}

const CancelStakeSaverModal = ({ onCancel }) => {
  const { onModalClose } = useModalContext();

  return (
    <>
      <div className="css-cancel-content">
        <ExclamationIcon />
        <div className="css-text-group">
          <h3 className="css-cancel-title">Cancel Stake Saver?</h3>
          <p className="css-cancel-subtitle">
            You'll lose access to these benefits and be subject to Stake's minimum balance fee.
          </p>
        </div>
        <div className="css-benefits-list">
          {BENEFITS.map((benefit, i) => (
            <div className="css-benefit-row" key={i}>
              <RedXIcon />
              <div className="css-benefit-text">
                <span className="css-benefit-title">{benefit.title}</span>
                <span className="css-benefit-desc">{benefit.description}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="css-cancel-actions">
          <button className="css-keep-btn" onClick={onModalClose}>
            Keep My Benefits
          </button>
          <button className="css-cancel-anyway-btn" onClick={onCancel}>
            Cancel Anyway
          </button>
        </div>
      </div>
    </>
  );
};
